import { parseSvgStyle } from '@/icons/utils/svg-styles'
import { ISvgProps } from '@/icons/utils/svg-types'

export const SvgFilledRatingStar = (props: ISvgProps) => {
    return (
        <svg
            width="23"
            height="22"
            viewBox="0 0 23 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={parseSvgStyle(props)}
            className={props.className}
        >
            <path
                d="M11.6268 0.386047L15.0927 7.4078L22.8436 8.5407L17.2353 14.0033L18.5587 21.7205L11.6268 18.0749L4.69475 21.7205L6.01834 14.0033L0.409912 8.5407L8.16076 7.4078L11.6268 0.386047Z"
                fill={props.color}
            />
        </svg>
    )
}
